import Icon from '../components/Icon.vue'

Icon.register({
  'search-minus': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M304 192v32c0 6.6-5.4 12-12 12h-168c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zM505 476.7l-28.3 28.3c-9.4 9.4-24.6 9.4-33.9 0l-99.8-99.7c-4.5-4.5-7-10.6-7-17v-16.3c-35.3 27.6-79.7 44-128 44-114.9 0-208-93.1-208-208s93.1-208 208-208 208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136s-136 60.8-136 136 60.8 136 136 136 136-60.8 136-136z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/search-minus.js
// module id = 1662
// module chunks = 0